<template>
  <div class="carousel-item">
    <video autoplay loop muted controls :src="imgurl"></video>
  </div>
</template>

<script setup>
import { indexFileApi } from "@/api/index.js";
import { onMounted, ref } from "vue";
onMounted(()=>{
  getList();
})
let imgurl = ref('')
// 获取详情
const getList = () => {
  indexFileApi()
    .then((res) => {
      imgurl.value = res.file
    })
    .catch((err) => {
      console.log(err);
    });
};
</script>
<style scoped lang='scss'>
.carousel-item{
  background-color: #000;
  padding-top: 100px;
  video{
    width:100% ;
  }
}
</style>